<template>
<!-- プロジェクト更新情報入力画面 -->
<CCard>
  <CCardHeader>
    <strong>プロジェクト更新</strong>
  </CCardHeader>
  <CCardBody>
    <p><span class="asterisk">*</span>が付いている項目は必須入力項目です</p>
    <ValidationObserver ref="obs" v-slot="ObserverProps">
      <CRow v-if="message.length">
        <ul>
          <li style="color: red;" v-for="error in message" :key="error">{{ error }}</li>
        </ul>
      </CRow>
      <CRow>
        <CCol sm="2">
          <label>顧客会社名<span class="asterisk">*</span></label>
          <ValidationProvider name='顧客会社名' rules="select" v-slot="ProviderProps">
            <select class="custom-select" v-model="company_id">
              <option disabled value="">選択してください</option>
              <option v-for="option in options1" :value="option.id" :key="option.id">{{ option.name }}</option>
            </select>
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <ValidationProvider name='プロジェクト名' rules="required" v-slot="ProviderProps">
            <label>プロジェクト名<span class="asterisk">*</span></label>
            <CInput v-model="project_name" maxlength="30"/>
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <label>自社管理者<span class="asterisk">*</span></label>
          <ValidationProvider name='自社管理者' rules="select" v-slot="ProviderProps">
            <select class="custom-select" v-model="own_staff_id">
              <option disabled value="">選択してください</option>
              <option v-for="option in options2" :value="option.id" :key="option.id">{{ option.name }}</option>
            </select>
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <ValidationProvider name='顧客会社担当者' v-slot="ProviderProps">
            <label>顧客会社担当者</label>
            <CInput v-model="staff_name" maxlength="20"/>
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <ValidationProvider name='関連会社' v-slot="ProviderProps">
            <CInput label="関連会社" v-model="related" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <ValidationProvider name='その他関連' v-slot="ProviderProps">
            <CInput label="その他関連" v-model="other_related" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
    <hr>
      <CRow>
        <CCol sm="2">
          <ValidationProvider name='始業時刻' rules="required" v-slot="ProviderProps">
            <label>始業時刻<span class="asterisk">*</span></label>
            <CInput type="time" v-model="start_time" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <ValidationProvider name='終業時刻' rules="required" v-slot="ProviderProps">
            <label>終業時刻<span class="asterisk">*</span></label>
            <CInput type="time" v-model="end_time" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <ValidationProvider name='休憩開始時間' rules="required" v-slot="ProviderProps">
            <label>休憩開始時間<span class="asterisk">*</span></label>
            <CInput type="time" v-model="break_start_time" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <ValidationProvider name='休憩終了時間' rules="required" v-slot="ProviderProps">
            <label>休憩終了時間<span class="asterisk">*</span></label>
            <CInput type="time" v-model="break_end_time" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <ValidationProvider name='契約形態' rules="required" v-slot="ProviderProps">
            <label>契約形態<span class="asterisk">*</span></label>
            <CInput v-model="contract"/>
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <ValidationProvider name='基準時間' rules="required|base_time" v-slot="ProviderProps">
            <label>基準時間<span class="asterisk">*</span></label>
            <CInput append="H" v-model="base_time" placeholder="(例)150-200,無し等" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <ValidationProvider name='基準時間(下限)' rules="num|base_time_min" v-slot="ProviderProps">
            <label>基準時間(下限)</label>
            <CInput append="H" v-model="base_time_min" 
              maxlength="3" 
              @beforeinput.native="digitsOnly('baseTimeMin', $event)"
              @input.native="sanitizeDigits('baseTimeMin')"
              placeholder="(例)140" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <ValidationProvider name='基準時間(上限)' rules="num|base_time_max" v-slot="ProviderProps">
            <label>基準時間(上限)</label>
            <CInput append="H" v-model="base_time_max" 
              maxlength="3" 
              @beforeinput.native="digitsOnly('baseTimeMax', $event)"
              @input.native="sanitizeDigits('baseTimeMax')"
              placeholder="(例)180" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="4">
          <ValidationProvider name='その他契約事項' v-slot="ProviderProps">
            <CInput label="その他契約事項" v-model="other_contract" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
     </CRow>
    <hr>
     <CRow>
        <CCol sm="3">
          <ValidationProvider name='開発言語' rules="required" v-slot="ProviderProps">
            <label>開発言語<span class="asterisk">*</span></label>
            <CInput v-model="language" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="3">
          <ValidationProvider name='その他必要技術' v-slot="ProviderProps">
            <CInput label="その他必要技術" v-model="other_tech" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow class="mt-3 align-items-center">
        <!-- 左寄せ：戻る -->
        <CCol class="text-start">
          <button class="btn btn-secondary" @click="valueCheck">戻る</button>
        </CCol>
        <!-- 横並び：確認 -->
        <CCol class="text-center">
          <button v-on:click="openModal" class="btn btn-info" :disabled="ObserverProps.invalid">確認</button>
          <!-- 更新確認モーダルコンポーネント呼出 -->
          <ProjectUpdateModal 
            :draggable="true" 
            :resizable="true" 
            :project="project_name" 
            :start="start_time" 
            :end="end_time"
            :restStart="break_start_time" 
            :restEnd="break_end_time" 
            :company="company_name" 
            :staff="staff_name" 
            :own_staff="own_staff_name"
            :related="related" 
            :contract="contract" 
            :otherRelated="other_related" 
            :baseTime="base_time" 
            :baseTimeMin="base_time_min" 
            :baseTimeMax="base_time_max" 
            :otherContract="other_contract"
            :language="language" 
            :otherTech="other_tech"
            :loading="loading"
            v-show="showModal" 
            @update="update" 
            @close="closeModal">
          </ProjectUpdateModal>
        </CCol>
        <!-- 空白スペース用 -->
        <CCol ></CCol>
      </CRow>
    </ValidationObserver>
  </CCardBody>
</CCard>
</template>

<script>
import ConstList from './../ConstList'
import ProjectUpdateModal from './ProjectUpdateModal'
import axios from 'axios'
export default {
  name: 'ProjectUpdate',
  components: {
    ProjectUpdateModal
  },
  data() {
    return {
      showModal: false,
      project_name: '',
      start_time: '',
      end_time: '',
      break_start_time: '',
      break_end_time: '',
      related:'',
      contract:'',
      other_related:'',
      base_time:'',
      base_time_min: '',
      base_time_max: '',
      other_contract:'',
      language:'',
      other_tech:'',
      company_id: '',
      company_name: '',
      options1: [],
      company_check: [],
      staff_name: '',
      own_staff_id: '',
      own_staff_name: '',
      options2: [],
      user_check: [],
      message: [],
      check: [],
      // 二重サブミット対処フラグ
      submit_flg: false,
      loading: false,
    }
  },
  methods: {
    // プロジェクト詳細へ遷移する際の入力値チェック
    valueCheck: function () {
      if ((this.project_name) || (this.start_time) || (this.end_time) || (this.break_start_time) || (this.break_end_time) || (this.company_id) || (this.staff_name) || (this.own_staff_id)
      || (this.related) || (this.contract) || (this.other_related) || (this.base_time) || (this.other_contract) || (this.language) || (this.other_tech)) {
        if (confirm(ConstList.TRANSITION)) {
          this.$router.push({
            name: ConstList.ROUTE_PROJECT_INFO,
            params: {
              value: this.$route.params.value
            }
          })
        }
      } else {
        this.$router.push({
          name: ConstList.ROUTE_PROJECT_INFO,
          params: {
            value: this.$route.params.value
          }
        })
      }
    },
    // モーダルを表示
    openModal: function () {
      // 二重サブミット対策
      if (this.submit_flg) return;
      // 会社名取得
      this.company_check.forEach((value, i, array) => {
        if (this.company_id === array[i][ConstList.ID]) {
          this.company_name = array[i][ConstList.NAME]
        }
      })
      // 自社管理者名取得
      this.user_check.forEach((value, i, array) => {
        if (this.own_staff_id === array[i][ConstList.ID]) {
          this.own_staff_name = array[i][ConstList.NAME]
        }
      })
      // モーダル表示（toggle）
      this.showModal = true
    },
    // 更新情報を送信
    update: function () {
      this.loading = true;
      let _start_time = this.start_time + ':00'
      let _end_time = this.end_time + ':00'
      let _break_start_time = this.break_start_time + ':00'
      let _break_end_time = this.break_end_time + ':00'
      // JSON形式パラメータ設定
      const params = {
        id : this.$route.params.value.id,
        name : this.project_name,
        start_time : _start_time,
        end_time: _end_time,
        break_start_time : _break_start_time,
        break_end_time : _break_end_time,
        company_id : this.company_id,
        staff_name : this.staff_name,
        user_id : this.own_staff_id,
        related : this.related,
        contract : this.contract,
        other_related : this.other_related,
        base_time : this.base_time,
        base_time_min : this.base_time_min,
        base_time_max : this.base_time_max,
        other_contract : this.other_contract,
        language : this.language,
        other_tech : this.other_tech
      }
      axios
        .post((process.env.VUE_APP_API_ORIGIN) + '/projectUpdate', params,  
          { headers: {
             // content-type指定。@requestBodyでサーバ側にてバインドするため。
             'Content-Type': 'application/json' 
          }},)
        .then(() => {
          alert(ConstList.REGISTER_MESSAGE)
          this.showModal = false
          // プロジェクト管理画面へ遷移する
          this.$router.push({
            name: ConstList.ROUTE_PROJECT_LIST
          })
        })
        .catch(error => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          })
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // モーダルを閉じる
    closeModal: function () {
      this.showModal = false
    },
    // 未然ブロック（半角数字以外）
    digitsOnly(field, e) {
      if (!e.inputType || !e.inputType.startsWith('insert')) return;
      const t = e.target;
      const data = e.data ?? '';
      const start = t.selectionStart ?? t.value.length;
      const end = t.selectionEnd ?? t.value.length;
      const next = t.value.slice(0, start) + data + t.value.slice(end);
      if (!/^\d*$/.test(next)) e.preventDefault();
    },

    // 最終サニタイズ（非数字除去 + 3桁制限）
    sanitizeDigits(field) {
      const cur = String(this[field] ?? '');
      const cleaned = cur.replace(/[^\d]/g, '').slice(0, 3);
      if (cur !== cleaned) this[field] = cleaned;
    },
  },

  // DBから各種情報を取得
  mounted: function () {
    {
      axios
        .get((process.env.VUE_APP_API_ORIGIN) + '/company')
        .then(response => {
          this.options1 = response.data
          this.company_check = this.options1
        })
        .catch(error => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          })
        })
    } {
      axios
        .get((process.env.VUE_APP_API_ORIGIN) + '/manager')
        .then(response => {
          this.options2 = response.data
          this.user_check = this.options2
        })
        .catch(error => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          })
        })
    }
    this.project_name = this.$route.params.value.name
    this.start_time = this.$route.params.value.start_time
    this.end_time = this.$route.params.value.end_time
    this.break_start_time = this.$route.params.value.break_start_time
    this.break_end_time = this.$route.params.value.break_end_time
    this.company_id = this.$route.params.value.company_id
    this.company_name = this.$route.params.value.company_name
    this.staff_name = this.$route.params.value.staff_name
    this.own_staff_id = this.$route.params.value.user_id
    this.own_staff_name = this.$route.params.value.private_staff_name
    this.related = this.$route.params.value.related
    this.contract = this.$route.params.value.contract
    this.other_related = this.$route.params.value.other_related
    this.base_time = this.$route.params.value.base_time
    this.base_time_min = this.$route.params.value.base_time_min
    this.base_time_max = this.$route.params.value.base_time_max
    this.other_contract = this.$route.params.value.other_contract
    this.language = this.$route.params.value.language
    this.other_tech = this.$route.params.value.other_tech
    this.check = this.$route.params.value
  }
}
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
}

</style>
